import { useContext } from "react";
import { useQuery, useQueryClient } from "react-query";
import { AppContext } from "../common/AppContext";
import { UserTrainings } from "../data/users/UserTrainings";

type Props = {
  params: Record<string, string | number>;
  enabled?: boolean;
};

const useLoadTrainings = ({ params, enabled }: Props) => {
  const context = useContext(AppContext);
  const queryClient = useQueryClient();

  const employeeId = params?.employeeId;
  const queryKey = ["LOAD_TRAININGS", employeeId];

  const cachedData: any = queryClient.getQueryData(queryKey);

  const query = useQuery({
    queryKey,
    queryFn: () => UserTrainings.get(context, employeeId),
    select: (res: any) => res.trainings,
    enabled: enabled,
    initialData: cachedData?.trainings
  });

  return {
    trainings: query.data,
    ...query
  };
};

export default useLoadTrainings;
